import classNames from "classnames";
import { ChangeEventHandler, useRef, useState } from "react";
import { CapitalizeKeys, Prefix } from "utils/typemap";
import { PropsWithClass, PropsWithClassAndStyle, PropsWithPrefixClassAndStyle, PropsWithPrefixStyle } from "utils/props";
import { Input, InputProps } from "./Input";
import { CurrentUserProps } from "api/user";
import { ArticleCard } from "components/Article";
import Button, { ButtonV2 } from "components/Button";
import { Navbar } from "components/Navbar";
import { useAPIFetch } from "hooks/fetch";
import MeiliSearch from "meilisearch";
import { Articlev2 } from "models/article";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { Meilisearch } from "utils/meilisearch";
import { twMerge } from "tailwind-merge";



export type SearchBoxProps = PropsWithClassAndStyle<{
  query?: string;
  setQuery: (v: string) => void;
  onSubmit?: () => any;
  explicit?: boolean;
}>

export type SearchBoxPropsV1 = SearchBoxProps & Prefix<CapitalizeKeys<PropsWithClassAndStyle<{}>>, 'parent'> & Omit<InputProps, 'value' | 'setValue'>;
export type SearchBoxPropsV2 = SearchBoxProps & PropsWithPrefixClassAndStyle<{}, 'child'> & { variant?: 'light' | 'dark' } & InputProps

export function SearchBox({
  query, setQuery,
  onSubmit, explicit, className, style,
  parentClassName, parentStyle,
  ...all
}: SearchBoxPropsV1) {
  return <form onSubmit={(e) => {
    e.preventDefault()
    if (onSubmit) onSubmit()
  }} className={classNames(parentClassName)} style={parentStyle}>
    <Input value={query} setValue={setQuery} className={classNames('h-full rounded-xl px-1', className)} style={style}  {...all} />
    {explicit && <Button type="submit" colorscheme="default">Найти</Button>}
  </form>
}


export function SearchBoxV2({
  query, setQuery,
  onSubmit, explicit, className, style,
  childStyle, childClassName,
  variant,
  ...all
}: SearchBoxPropsV2) {
  variant ??= 'light'
  return <form onSubmit={(e) => {
    e.preventDefault()
    if (onSubmit) onSubmit()
  }} className={twMerge(classNames("p-0.2", { 'flex gap-1': explicit }, className))} style={style}>
    <Input value={query} setValue={setQuery} className={twMerge(classNames('w-full rounded-xl px-0.5', { 'bg-light-grey text-dark-grey': variant === 'dark' }), childClassName)} style={childStyle} {...all} />
    {explicit && <ButtonV2 type="submit" colorscheme="default">Искать</ButtonV2>}
  </form>
}

// TODO: refactor to work with all kinds of entities
export function SearchResults({ initialQuery, style, className, entryOnClick }: PropsWithClassAndStyle<{ initialQuery?: string; entryOnClick?: (id: string) => void }>) {
  const [query, setQuery] = useState<string>(initialQuery as string);
  const [entries, setEntries] = useState<Partial<Articlev2>[]>([]);
  const updateEntries = () => Meilisearch.index('articles').search(query)
    .then(results => setEntries(results.hits
      .map(({ id, name, description }) => ({ id, metadata: { name, description } }) as Partial<Articlev2>)));
  useEffect(() => {
    updateEntries();
  }, []);
  return <div className={classNames("flex flex-col py-1", className)} style={style}>
    <div className="flex w-full gap-0.5 flex-row">
      <SearchBox query={query} setQuery={setQuery} parentClassName="w-full" className="w-full" />
      <Button onClick={() => updateEntries()}>Искать</Button>
    </div>
    <div className="flex flex-col gap-1 w-full py-2 overflow-y-auto">
      {entries.map(v => <ArticleCard article={v as Articlev2} onClick={entryOnClick} key={v.id} />)}
    </div>
  </div>
}

